import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const ActivityTimelineImage = () => {
  const data = useStaticQuery(graphql`
    query {
      ActivityTimelineImage: file(
        relativePath: { eq: "platform/offers/activity-timeline.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.ActivityTimelineImage.childImageSharp.fluid}
      alt="Activity Timeline Image"
    />
  )
}

export default ActivityTimelineImage
